module.exports = __webpack_public_path__ + "img/TV.d84e018c.svg";